import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";

const b9={
	display: 'flex',
	flexDirection: 'column'
}

const Header = (props) =>
	<header>
		<div onClick={() =>document.querySelector('aside').classList.add('active')} id='burger'>menu</div>
		{
			[...Array(18)].map((i,n) =>{
				switch(n){
					case 8:
						return (<div key={n} className={'anime b txt b-'+n}>
									привет. мы - современный тату салон. мы бы могли много о
									себе рассказывать и показать, но проще прити и увидеть это самому.
									И мы не всегда экономим свет.
								</div>);
						break;
					case 9:
						return (<div onClick={props.toChangeShadowToOff} style={b9} key={n} className={'anime b txt b-'+n}>
									<img src={require('../../img/lamp.png')}/>
									{props.shadowIsOff?'выключить свет':'включить свет'}
								</div>);
						break;
					case 12:
						return (<div key={n} className={'anime b txt b-'+n}>
									пн-пт<br/>10:00-17:00<br/>сб,вс<br/>выходной
								</div>);
						break;
					default: return (<div key={n} className={'anime b b-'+n}></div>)
				}
			}
			)
		}
	</header>

export default Header;